import { ApolloProvider } from '@apollo/client'
import { ChimeProvider } from '@/app/providers/ChimeProvider'
import { AppRoutes } from '@/app/routes'
import { apolloClient } from '@lib/apollo/client'

export function App() {
  return (
    <ApolloProvider client={apolloClient}>
      <ChimeProvider>
        <AppRoutes />
      </ChimeProvider>
    </ApolloProvider>
  )
}
